import React from "react";
import mainimage from "../../images/toperbackgroundimage.svg";
import { useNavigate } from "react-router-dom";
import newRequest from "../../utils/newRequest";
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import imageLiveUrl from "../../utils/urlConverter/imageLiveUrl";

function Aboutsection() {
  const navigate = useNavigate()
  const { t, i18n } = useTranslation();
  const { isLoading, error, data: stepData } = useQuery("fetchAllstep", fetchFeaturesData);

  async function fetchFeaturesData() {
    const response = await newRequest.get("/getAllsteps");
    // return response?.data.filter(item => item.status === 1) || [];
    return response?.data.filter(item => item.status === 1).sort((a, b) => a.caption - b.caption) || [];
  }


    const { isLoadingabout, errorabout, data: aboutData } = useQuery("fetchAllabout", fetchFeaturesDataabout);

  async function fetchFeaturesDataabout() {
    const response = await newRequest.get("/getAllsection2");
    return response?.data.filter(item => item.status === 1) || [];
  }
  return (
    <>
      {/* Step1 */}
      {isLoading ? (
        <div className="flex justify-center items-center h-[420px]">
          <p>Loading....</p>
        </div>
      ) : error ? (
        ""
      ) : (
        stepData &&
        stepData.map((item, index) => (
          <div
            className="mt-10 "
            // className="relative w-full h-[90vh]  bg-cover bg-center"
            // style={{ backgroundImage: `url(${mainimage})` }}
          >
            <div className="py-10">
              <div className={`w-full px-4 md:px-20`} key={index}>
                <div
                  className={`flex flex-wrap justify-center items-center flex-row sm:flex-col ${
                    index % 2 === 0
                      ? `${
                          i18n.language === "ar"
                            ? "md:flex-row"
                            : "md:flex-row-reverse"
                        }`
                      : `${
                          i18n.language === "ar"
                            ? "md:flex-row-reverse"
                            : "md:flex-row"
                        }`
                  } $`}
                >
                  <div className={`w-full md:w-1/2 px-3 `}>
                    <img
                      src={imageLiveUrl(item.image)}
                      className="h-auto sm:w-[100%] w-full object-contain"
                      alt={`Step ${item.caption}`}
                    />
                  </div>
                  <div
                    className={`w-full  md:w-2/4 sm:py-0 py-4 sm:px-0 px-3 ${
                      i18n.language === "ar" ? "text-right" : "text-left "
                    }`}
                  >
                    <p className="mb-3 font-bold text-xl font-sans">
                      Step {item.caption}
                    </p>
                    <h2 className="mb-5 font-extrabold text-[2.625rem] leading-[calc(50/42)] tracking-[-1px] text-[#1d2331] font-lato">
                      {i18n.language === "ar" ? item.title_ar : item.title}
                    </h2>
                    <p className="font-sans text-[#596175] text-xl">
                      {i18n.language === "ar"
                        ? item.description_ar
                        : item.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
      )}

      {isLoadingabout ? (
        <div className="flex justify-center items-center h-[420px]">
          <p>Loading....</p>
        </div>
      ) : errorabout ? (
        ""
      ) : (
        aboutData &&
        aboutData.map((item, index) => (
          <div className="mt-20 text-center">
            <h2 className="text-4xl leading-tight font-bold text-[#1d2331] font-lato">
              {i18n.language === "ar" ? item.title_ar : item.title}
            </h2>
            <div className="w- flex justify-center items-center text-center ">
              <p class="w-3/4 my-7 sm:w-full md:w-3/4 text-base leading-relaxed text-[#596175]">
                {i18n.language === "ar"
                  ? item.description_ar
                  : item.description}
              </p>
            </div>
            <button
              onClick={() => navigate(`${item.url}`)}
              className="bg-[#f0452b] text-white mx-3 px-8 border border-[#f0452b] hover:bg-[#2b4892] hover:border-[#2b4892]  py-2 text-lg font-bold  rounded-md transition-all duration-300  transform "
            >
              {t(`${item.button}`)}
            </button>
          </div>
        ))
      )}
    </>
  );
}

export default Aboutsection;
